<template>
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19.36">
        <g id="Icon_feather-menu">
            <g id="Path_1190">
                <path
                    class="cls-2"
                    d="M11.46,10.69H4.95c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h6.51c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75Z"
                />
            </g>
            <g id="Path_1191">
                <path
                    class="cls-2"
                    d="M8.4,6.69h-3.45c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h3.45c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75Z"
                />
            </g>
            <g id="Path_1192">
                <path
                    class="cls-2"
                    d="M11.46,14.69H4.95c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75h6.51c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75Z"
                />
            </g>
        </g>

        <g id="Rectangle_2846">
            <rect class="cls-1" width="16" height="19.36" rx="3" ry="3" />
            <path
                class="cls-2"
                d="M13,19.36H3C1.35,19.36,0,18.01,0,16.36V3C0,1.35,1.35,0,3,0H13C14.65,0,16,1.35,16,3v13.36c0,1.65-1.35,3-3,3ZM3,1.5c-.83,0-1.5,.67-1.5,1.5v13.36c0,.83,.67,1.5,1.5,1.5H13c.83,0,1.5-.67,1.5-1.5V3c0-.83-.67-1.5-1.5-1.5H3Z"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'ReportIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 14.87px;
    height: 16.99px;
    margin: auto;

    .cls-1 {
        fill: none;
    }
    .cls-2 {
        fill: $white;
    }

    &:hover {
        .cls-2 {
            fill: $blue;
        }
    }
}
</style>
